// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";

// Sub-Components

// Data / Images / Icons

function P_Workshops() {
  return (
    <DefaultLayout>P_Workshops</DefaultLayout>
  )
}

export default P_Workshops